import { IJsonQueryDeveloper } from 'packages/api-models/common/json_query';
import { getGeoValueByType, getTermsValue, resetTerms, setGeo } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'builder';

export const builderTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery, geoTags }) => {
    const builders = getTermsValue('builders_ids')(jsonQuery);

    if (!builders?.length) {
      return null;
    }

    const builderId = builders[0];

    const label = geoTags.developers[builderId] || `Неизвестный застройщик #${builderId}`;

    return [{ label, value: createTagValue(ID, String(builderId)) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const newJsonQuery = resetTerms(['builders_ids', 'builder'])(jsonQuery);

    const values = getGeoValueByType<IJsonQueryDeveloper>('builder')(newJsonQuery);

    if (!values) {
      return newJsonQuery;
    }

    const newValues = values.filter(({ id }) => String(id) !== removingTagValue);

    return setGeo()(newJsonQuery)(newValues);
  },
};
